import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="filter"
export default class extends Controller {
  static values = { param: String }

  apply(event) {
    const url = new URL(window.location)
    const value = event.target.type === 'checkbox' ? (event.target.checked ? '1' : '0') : event.target.value
    
    url.searchParams.set(this.paramValue, value)
    url.searchParams.delete('page') // Reset pagination when filtering
    url.searchParams.delete('clear') // Remove clear param when actively filtering
    
    Turbo.visit(url)
  }
}
